export const BRAND = {
  name: "Vivan Energia",
  proprietor: "Ankit Tiwari",
  address: "Amprall Yojna, Dubagga, Lucknow - 226101",
  phones: ["+91 9616356356", "+91 9930171156"],
  whatsapp: "919616356356",
  email: "vivanenergia15@gmail.com",
  gstin: "09BNMPT2397D1ZG",
};

export const waLink = (text = "Hi Vivan Energia, I'd like a Free Site Visit & Customized Quotation.") =>
  `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(text)}`;

export const NAV = [
  { id: "home", label: "Home" },
  { id: "amc", label: "Solar AMC Plans" },
  { id: "installation", label: "Installation Services" },
  { id: "addons", label: "Add-On Services" },
  { id: "contact", label: "Contact Us" },
];

export const PACKAGES = [
  {
    id: "p1",
    tag: "Service Package 01",
    title: "Normal Structure",
    sub: "1-Day Material Availability with Normal Structure",
    tiers: [
      { cap: "Up to 8 kW", rows: [{ k: "Tata & Aavada Panels", v: "2.50", note: "with warranty inspection" }, { k: "Other Panels", v: "2.00" }] },
      { cap: "Above 8 kW", rows: [{ k: "Tata Panels", v: "2.25", note: "with warranty inspection" }, { k: "Other Panels", v: "1.75" }] },
    ],
  },
  {
    id: "p2",
    tag: "Service Package 02",
    title: "Broad Structure / Delayed Delivery",
    sub: "1-Day Full Material Availability with Broad Structure or Delayed Material Delivery",
    tiers: [
      { cap: "Up to 8 kW", rows: [{ k: "Tata Panels", v: "3.00", note: "with warranty inspection" }, { k: "Other Panels", v: "2.50" }] },
      { cap: "Above 8 kW", rows: [{ k: "Tata Panels", v: "2.50", note: "with warranty inspection" }, { k: "Other Panels", v: "2.00" }] },
    ],
  },
];

export const TENURES = [
  { id: "yearly", label: "Yearly", months: 12, hint: "Best value · Advance" },
  { id: "half", label: "6-Month", months: 6, hint: "Flexible half-yearly" },
  { id: "monthly", label: "Monthly", months: 1, hint: "Pay as you go" },
];

export const AMC = [
  { cap: "3 kW", yearly: 399, half: 499, monthly: 599, badge: "Save 33%" },
  { cap: "4 kW", yearly: 499, half: 599, monthly: 699, badge: "Save 28%" },
  { cap: "5 kW", yearly: 599, half: 699, monthly: 799, badge: "Save 25%" },
  { cap: "6 kW", yearly: 699, half: 799, monthly: 899, badge: "Save 22%" },
  { cap: "7 kW", yearly: 799, half: 899, monthly: 999, badge: "Save 20%" },
  { cap: "8-10 kW", yearly: 999, half: 1099, monthly: 1299, badge: "Best Deal" },
];

export const STATS = [650, 450, 3, 100];

export const REVIEWS = [
  {
    name: "Akash Soni",
    area: "Dubagga, Lucknow",
    rating: 5,
    text: "Bahut hi jabardast services hai, mai up-neda ragisterd vendor hun vivan energia guideline ke according hi installation karwate hai zero complaint clint bhi bahut kush hai or mai bhi.",
  },
  {
    name: "Himanshu Shrivastava",
    area: "Balagunj, Lucknow",
    rating: 5,
    text: "Installation services is very accurate and proper according to the guideline. 👍🏻",
  },
  {
    name: "Mukesh Gupta (Supertek)",
    area: "TP Nagar, Lucknow",
    rating: 5,
    text: "Excellent and Compliant Solar Installation! I recently got a solar power system installed by Vivan Energia, and I am thoroughly impressed with their professionalism and quality of work. They strictly followed all the official UP NEDA guidelines throughout the installation process, ensuring complete safety and compliance. What impressed me the most was their attention to detail—especially setting up the proper tilt and slope for the solar panels. This ensures maximum sunlight absorption so that we get optimal power generation all 12 months of the year. Highly recommended if you are looking for a reliable, hassle-free, and standard-compliant solar setup!",
  },
  {
    name: "Abhay Singh (Guru Battery and Electricals)",
    area: "Shanti Nagar, Lucknow",
    rating: 5,
    text: "Highly Professional Team and Zero Complaints! I have been working with Vivan Energia for over a year now and have had multiple solar installations completed through them. Their entire team and technical staff are well-educated, highly skilled, and extremely well-behaved. The quality of work across all my sites has been flawless, and I haven't faced a single issue or complaint in any of the installations so far. If you are looking for top-notch quality and a reliable solar partner, I strongly recommend Vivan Energia!",
  },
];

export const INCLUSIONS = {
  yearly: ["4 Water Cleaning Visits (Quarterly)", "2 Full Electrical Audits / yr", "Free Inverter Health Check", "Earthing Pit Resistance Test", "Priority 24 Hr Support"],
  half: ["2 Water Cleaning Visits in 6 Mo", "1 Electrical Audit / 6 Mo", "ACDB/DCDB & Fuse Checkup", "Wiring Loose Connection Test", "48 Hr On-Site Visit"],
  monthly: ["1 Dedicated Water Cleaning", "Basic Visual Reporting", "Inverter Code Check", "Immediate Issue Reporting", "Pay-As-You-Go Reporting"],
};

export const AMC_SERVICES = [
  { t: "High-Pressure Panel Cleaning", d: "Boosts generation by 15-20% — 4 cleanings a year or 2 in six months." },
  { t: "Electrical & Inverter Safety", d: "ACDB/DCDB box, wire tightness, inverter parameters and MCB checking." },
  { t: "Earthing & LA Inspection", d: "Earthing pits and lightning arrestors checked to prevent electric shock." },
  { t: "Breakdown On-Call Support", d: "Priority engineer visit for faults or shutdowns. Emergency visit ₹500 + 18% GST." },
];

export const AMC_TERMS = [
  "All subscription rates are exclusive of 18% GST (CGST 9% + SGST 9%).",
  "Annual and 6-month plans require full advance payment at order confirmation.",
  "For cleaning pumps, continuous roof water supply and a 220V power socket are required.",
  "AMC covers service & labour only — damaged spare parts are billed to the customer.",
  "Dismantling & re-installation of a previously wrong installation is charged separately.",
];

export const ADDONS = [
  { t: "Sprinkler fitting", s: "At time of installation", p: "₹0.50", u: "/ PW" },
  { t: "Sprinkler fitting", s: "After installation", p: "₹1.00", u: "/ PW" },
  { t: "Site dismantling", s: "Panels & structure", p: "₹1.00", u: "/ PW" },
  { t: "Grid connection", s: "ACDB, DCDB", p: "₹500", u: "" },
  { t: "L/A change", s: "Lightning arrestor", p: "₹500", u: "" },
  { t: "Routing", s: "Cable routing", p: "₹1.00", u: "/ PW" },
  { t: "Structure installation", s: "With grouting only", p: "₹1.50", u: "/ PW" },
  { t: "Earthing only", s: "Per earthing", p: "₹300", u: "" },
  { t: "Visit charge", s: "Site visit", p: "₹500", u: "" },
];

export const WASH = [
  { cap: "3 kW", p: "₹399" },
  { cap: "4 kW", p: "₹499" },
  { cap: "5 kW", p: "₹599" },
];

export const BENEFITS = [  "Proper installation completed in one shot.",
  "1-day site finish guarantee.",
  "1-year rectification guarantee service only (free materials provided for any damage during installation).",
  "Free site visits for structure / material quotes.",
  "Free site running visits after meter confirmation.",
  "Full responsibility for returning extra materials.",
  "Free labour support for material loading / unloading.",
  "Trained, educated, well-behaved staff with zero complaint assurance.",
  "Complete peace of mind.",
];
